<div class="border bg-white pad15 position-relative">
    <div class="ctm-tab custom-card card-accord" *ngIf="SstCheckList?.length>0; else load_elsePart">
        <ng-container *ngIf="inspectionCheckList?.length > 0">
            <ngb-accordion class="main">
                <ngb-panel>
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center abc text-left"
                                aria-label="Center Align" translate>
                                lblInspectionSstCheckList
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="row">
                            <div class="row d-flex flex-wrap">
                                <div class="col-md-12" *ngFor="let item of inspectionCheckList; let i=index">
                                    <div class="dwo-card shadow-none border" style="height: 30px;">
                                        <div class="col-md-6" style="padding-top:5px;">
                                            <h4 class="title-h5">{{i + 1}}.&nbsp;&nbsp;{{item.inspectionDescription}}
                                            </h4>
                                        </div>
                                        <div class="col-md-3" style="padding-top:5px;">
                                            <ng-container *ngFor="let clr of SstColors;">
                                                <div class="d-inline-block mr-2">
                                                    <label class="mr10">
                                                        <input type="radio" class="radio-custom"
                                                            style="border-width: 2px;" [style.border-color]="clr"
                                                            [checked]="item.inspectionColor == clr" disabled />
                                                    </label>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="col-md-3" style="padding-top:5px;">
                                            <h4>{{item.inspectionNote}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </ng-container>
        <ng-container *ngIf="tyreCheckList?.length > 0">
            <ngb-accordion class="main">
                <ngb-panel>
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center abc text-left"
                                aria-label="Center Align" translate>
                                lblTyreSstCheckList
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="row d-flex flex-wrap">
                            <div class="col-md-12" *ngFor="let item of tyreCheckList; let i=index">
                                <div class="dwo-card shadow-none border" style="height: 30px;">
                                    <div class="col-md-6" style="padding-top:5px;">
                                        <h4 class="title-h5">{{i + 1}}.&nbsp;&nbsp;{{item.inspectionDescription}}
                                        </h4>
                                    </div>
                                    <div class="col-md-3" style="padding-top:5px;">
                                        <ng-container *ngFor="let clr of SstColors;">
                                            <div class="d-inline-block mr-2">
                                                <label class="mr10">
                                                    <input type="radio" class="radio-custom" style="border-width: 2px;"
                                                        [style.border-color]="clr"
                                                        [checked]="item.inspectionColor == clr" disabled />
                                                </label>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="col-md-3" style="padding-top:5px;padding-bottom:5px;">
                                        <h4>{{item.inspectionNote}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </ng-container>
    </div>
    <ng-template #load_elsePart>
        <div class="no-record" translate>lblNoCheckListFound</div>
    </ng-template>
</div>